import { getV2Endpoint } from '@/utils/apiV2Endpoints';
import KmsHttpService from '@/servises/kmsHttpService';

export default {
    deleteSite: (id) => {
        const endpoint = getV2Endpoint({ 'group': 'sites', 'endpoint': 'manage' }, { id: id });
        return KmsHttpService.delete(endpoint, null);
    }
};
